import { t } from "i18n/i18n";
import { LegacyButton } from "mds/components/LegacyButton";
import { useCapabilities } from "store/capability-hooks";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectIsStudentPreview, selectQueryString } from "store/selectors";
import { viewStateActions } from "store/slices/view";

export const StudentPreview = () => {
  const dispatch = useAppDispatch();

  const queryString = useAppSelector(selectQueryString);
  const { canAuthorSection } = useCapabilities();
  const isStudentPreview = useAppSelector(selectIsStudentPreview);

  return (
    <>
      {isStudentPreview && (
        <LegacyButton
          className="mt-4 w-full max-w-full justify-start"
          eventName="Account settings - Stop preview as a student"
          kind="secondary"
          onClick={() => dispatch(viewStateActions.setIsStudentPreview(false))}
        >
          {t("profile_panel.stop_student_preview")}
        </LegacyButton>
      )}

      {!isStudentPreview && canAuthorSection && (
        <LegacyButton
          className="mt-4 w-full max-w-full justify-start"
          eventName="Account settings - Preview as a student"
          kind="secondary"
          to={{ pathname: ".", search: `?${queryString}&student=1` }}
          onClick={() => dispatch(viewStateActions.setIsStudentPreview(true))}
        >
          {t("section.sidebar.planner.preview_as_student")}
        </LegacyButton>
      )}
    </>
  );
};
